import {
  Box,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import CopyIcon from "src/components/Icon/CopyIcon";
import Empty from "src/components/utils/Empty";
import { TOP_COLOR_LIST } from "src/config/styleConfig";
import { formatAddress, toFixed } from "src/services/utils";

const useStyle = makeStyles(() => ({
  icon: {
    fontSize: "14px",
  },
}));

export default function BaseTable({ tableHeaderConfig, data }) {
  const cls = useStyle();

  return (
    <>
      <TableContainer style={{ borderRadius: "10px" }}>
        <Table>
          <TableHead>
            <TableRow>
              {tableHeaderConfig.map((element, index) => {
                return (
                  <TableCell colSpan={element?.colSpan} key={index}>
                    <Typography>{element["title"]}</Typography>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          {data && (
            <TableBody>
              {data.map((element, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell colSpan={tableHeaderConfig[0].colSpan} style={{ padding: "0.5rem 1rem" }}>
                      <Box display="flex" justifyContent="flex-start" alignItems="center">
                        <div
                          style={{
                            width: "12px",
                            height: "12px",
                            marginRight: "0.25rem",
                            borderRadius: "2px",
                            background: TOP_COLOR_LIST[index],
                          }}
                        ></div>
                        <Typography>Top {index + 1}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell colSpan={tableHeaderConfig[1].colSpan} style={{ padding: "0.5rem 1rem" }}>
                      <Box display="flex" justifyContent="flex-start" alignItems="center">
                        <Typography>{formatAddress(element.address)}</Typography>
                        <CopyIcon
                          defaultText="Copy address"
                          copyText={element.address}
                          successText="Copied!"
                          classes={{
                            iconButton: cls.iconButton,
                            icon: cls.icon,
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell colSpan={tableHeaderConfig[2].colSpan} style={{ padding: "0.5rem 1rem" }}>
                      <Typography>{toFixed(element.score, 2)}</Typography>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {!data && (
        <Box display="flex" justifyContent="center">
          <Empty title="No Data" iconProps={{ style: { fontSize: "60px" } }} />
        </Box>
      )}
    </>
  );
}
